export default "__VITE_ASSET__f9ce79c9__"